<template>
    <div class="col backgroundForm">
        <div class="col-md-6 offset-md-3">
            <div class="alert alert-info" align="center" role="alert">
                <h4 class="alert-heading">Registro de Permisos y Certificados Empresas</h4>
                <p>Realiza la Busqueda y validez de Certificados a Personas y/o Empresas </p>       
            </div>
        </div>
        
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#search-owner" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Busqueda Propietario</a>
            </div>
        </nav>
                
        <div class="tab-content" id="nav-tabContent">                
            <div class="tab-pane fade show active" id="search-owner" role="tabpanel" aria-labelledby="nav-new-tab" >
                <br>
                        
                        <h6 align="center">Busqueda y Seleccion de Propietario(s) u Empresa</h6>
                        <hr>
                        <!-- embarcacion encontrada -->
                        <transition name="fade" mode="out-in">
    
                        <div v-if="empresa_persona_select.id > 0" class="panel panel-default">
                            <!-- aca va el formulario de registro -->
                            <h6 align="left">Nuevo Registro</h6>
                            <hr>
                            <div class="form-row">
                                <div class="form-group col-12 col-md-4">
                                    <label for="type_identification" class="badge badge-primary">Nombre Completo</label>
                                    <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="empresa_persona_select.name">
                                </div>
    
                                <div class="form-group col-12 col-md-4">
                                    <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                    <input type="text" class="form-control-plaintext" :value="empresa_persona_select.number_identification" name="number_identification" readonly>
                                </div>
    
                                <div class="form-group col-12 col-md-4">
                                    <label for="site_expedition" class="badge badge-primary">Telefono </label>
                                    <input type="text" class="form-control-plaintext" :value="empresa_persona_select.phone" name="number_identification" readonly>
                                </div>
                            </div>
    
                            <!-- aqui debe ir si ya tiene registrado algun certificado que indique -->
                            <div class="form-row">
                                <div class="input-group col-12 col-md-6">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Cuenca</span>
                                    </div>
                                    <select name="type_cert" id="type_cert" class="form-control" v-model="muelle_auxiliar">
                                        <option v-for="lc in cuencas" :key="lc.id" :value="lc">{{ lc.detail }}</option>
                                    </select>
                                </div>
                                <div class="input-group col-12 col-md-6">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Numero Certificado</span>
                                    </div>
                                    <input type="text" name="date_expedition" id="date_expedition" class="form-control" autocomplete="off" v-model="dts_certificate_empresa.certificate">
                                </div>
                                
                            </div>
                            <br>
                            
                            <div class="form-row">
                                <div class="input-group col-12 col-md-6">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Fecha Expedición</span>
                                    </div>
                                    <input type="date" name="date_expedition" id="date_expedition" class="form-control" autocomplete="off" v-model="dts_certificate_empresa.date_init">
                                </div>

                                <div class="input-group col-12 col-md-6">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Fecha Vencimiento</span>
                                    </div>
                                    <input type="date" name="date_expedition" id="date_expedition" class="form-control" autocomplete="off" v-model="dts_certificate_empresa.date_end">
                                </div>
                            </div>
    
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="enroll_uumm">Servicio que Presta</label>
                                    <textarea cols="50" rows="5" name="libro" id="detail_optional" class="form-control" placeholder="Limpieza y seguridad de embarcaciones ...." autocomplete="off" v-model="dts_certificate_empresa.service" ></textarea>
                                </div>
                            </div>
    
                            <button class="btn btn-success col-12 col-md-2 offset-md-4" @click="mSaveCertificatePerson"><font-awesome-icon icon="check-square" size="2x" /></button>
                            <button class="btn btn-danger col-12 col-md-2" @click="mCloseSelectPerson"><font-awesome-icon icon="times-circle" size="2x" /></button>
                            
                            <!-- aqui val el listado de los registros -->
                            <br><br>
                            <h6 align="left">Registro Anterior</h6>
                            <hr>
                            <div class="input-group col-12">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Numero de Registros</span>
                                    </div>
                                    <input type="number" min="1" class="form-control" v-model="cantidad_reg">
                                    <button class="btn btn-info" @click="mChargeCertificatesEmpresa(empresa_persona_select.id, cantidad_reg)">
                                        Listar
                                    </button>
                            </div>

                                    <table class="table sm">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Certificado</th>
                                            <th>Vigencia</th>
                                            <th>Cuenca</th>
                                            <th>Servicio</th>
                                            <th>Estado</th>

                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="cem, index in certificatesEmpresa" :key="cem.id">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ cem.numero_certificado }}</td>
                                                <td>{{ $dateWrite(cem.fecha_inicio) }} al {{ $dateWrite(cem.fecha_vencimiento) }}</td>
                                                <td>{{ cem.cuenca }}<br>{{ cem.detalle_puerto }}<br>{{ cem.nombre_muelle }}</td>
                                                <td>{{ cem.servicio_presta }}</td>
                                                <td class="alert" :class="'alert-'+cem.estilo">{{ cem.estado_certificado}}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                        </div>
    
                        <!-- busqueda de embarcacion -->
                        <div v-else>
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-success active" @click="mViewSearchPerson">
                                    <input class="form-check-input" type="radio" name="personSearch" id="personSearch1" v-model="optionSearchPerson" value="document" checked> Nombre 
                                </label>
                                <label class="btn btn-success" @click="mViewSearchPerson">
                                    <input class="form-check-input" type="radio" name="personSearch" id="personSearch2" v-model="optionSearchPerson" value="name">No. Documento
                                </label>
                            </div>
    
                            <div class="form-group"> 
                                <label for="nombrePersona">{{ searchTypePerson }}</label>
                                <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchTypePerson" autocomplete="off">
                                <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypePerson }} </small>
                            </div>
                        <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataPerson">Buscar</button>
    
                            <div class="table-responsive" v-if="list_empresa_persona_select.length > 0">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Nombre Completo</th>
                                            <th>CI / NIT</th>
                                            <th><font-awesome-icon icon="check"/></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(persSelc, index) in list_empresa_persona_select" :key="persSelc.id">
                                            <td>{{ index+1 }}</td>
                                            <td>
                                                <span>{{ persSelc.nombre_propietario }}</span>
                                            </td>
                                            <td>{{ persSelc.dato_identificacion }}</td>
                                            <td>
                                                <button class="btn btn-outline-info" @click="mSelectPersonOwner(persSelc)">
                                                    <font-awesome-icon icon="check"/>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
                        </transition>
                        
            </div>
            <!-- end first tab -->
    
        </div>
        <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
        <modal-report :id-modal-report="id_modal_r" :title="modal_report_t" :content="modal_report_c" :url-r="modal_report_url" :id-report="id_report"></modal-report>
    </div>
    </template>
    
    <script>
    import Vue from 'vue';
    import axios from 'axios';
    const qs = require('qs');
    
    import modalLoading from '../modal/modalLoading';
    import modalReport from '../modal/modalReport.vue';
    
    export default {
        name:'uumm-sign',
        data(){
            return{
                cantidad_reg:5,
                id_modal_r:'reportuumm',
                modal_report_t:'Certificados UUMM',
                modal_report_url:'pdfuumm',
                id_report:0,
                modal_report_c:null,
                description_transfer:null,
                owner:{},
                empresa_persona_select:{id:0},
                list_empresa_persona_select:[],
                ship_select:{id:0},
                list_ship_select:[],
                types_identification:[],
                citys:[],
                countrys:[],
                status_send:true,
                modal_load_id:'id_owner_new',
                modal_load_title:'Registrando', 
                optionSearchShip:'name',
                optionSearchPerson:'name',
                data_person:null,
                data_ship:null,
                optionSearch:'name',
                old_owner:{id:0},
                dts_transfer:null,
                types_certificado:[],
                categorys_owner:[],
                types_sectores:[],
                type_certificado_reg:[],
                charges_um:[],
                last_register_person:[],
                dts_certificate_empresa:{
                    id_empresa:0,
                    id_muelle:0,
                    date_init:'',
                    date_end:'',
                    certificate:'',
                    service:'',
                },
                muelle_auxiliar:{id:0},
                certificatesEmpresa:[],
                certificatesShips:[],
                muelles_lista:[],
                cuencas:[]
            }
        },
        mounted(){
            // if(Vue.auth.getToken()){
            //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
            // }
            // console.log(axios.defaults.headers)
            this.mCallInit();
        },
        methods:{
            async mCallInit(){
                // this.muelles_lista=[];
                // let muelle_call=await axios.get(`getMuellesRegisters/active?api_token=${Vue.auth.getToken()}`);

                // this.muelles_lista=muelle_call.data;

                let cuenca_aux = await axios.get(`globals/basin?api_token=${Vue.auth.getToken()}`);
                this.cuencas = cuenca_aux.data;
            },
            mValidateCertificatePerson(){
                if(this.muelle_auxiliar.id===0){
                    toastr.warning('Seleccione una Cuenca a Autorizar', 'Error');
                    return false;
                }
                if(this.dts_certificate_empresa.certificate.trim().length ===0){
                    toastr.warning('Debe indicar el certificado', 'Error');
                    return false;
                }
                if(this.dts_certificate_empresa.date_init.trim().length ===0){
                    toastr.warning('Seleccione la fecha de Expedición', 'Error');
                    return false;
                }
                console.log(this.dts_certificate_empresa.date_end);
                if(this.dts_certificate_empresa.date_end.trim().length ===0){
                    toastr.warning('Seleccione la fecha de Conclusion', 'Error');
                    return false;
                }
                if(this.dts_certificate_empresa.service.trim().length ===0){
                    toastr.warning('Indique el servicio que presta la empresa', 'Error');
                    return false;
                }
                return true;
            },
            async mSaveCertificatePerson(){
                // console.log(this.dts_certificate_one);
                if(this.mValidateCertificatePerson()){
                    let message = {
                        title: 'Registro de Vigencia de la Empresa',
                        body: `¿Desea realizar el registro para ${this.empresa_persona_select.name}, en los puertos correspondientes en la cuenca de ${this.muelle_auxiliar.detail} anulando todos los registros anteriores existentes?`
                    }
                    this.dts_certificate_empresa.id_empresa=this.empresa_persona_select.id;
                    this.dts_certificate_empresa.id_muelle=this.muelle_auxiliar.id;
                    // let aid=id;
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    // this.select_ordop=false;
                    // this.mResetFormProcesOrdop();
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            try {
                                // console.log(this.dts_certificate_one);
                                let reg_certificate = await axios.post(`insertCertificateEmpresaUM?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_certificate_empresa))
                                if(reg_certificate.data.status){
                                    toastr.success(reg_certificate.data.respuesta);
                                    this.mChargeCertificatesEmpresa(this.empresa_persona_select.id);
                                    this.mClearFormOwner();
                                }    
                            } catch (error) {
                                console.error(error);    
                            }
                            
                        }else{
                            console.log('no se ha registrado el certificado')
                        }
                        // console.log(reg_certificate);
                    })
    
                }
            },
            mClearFormOwner(){  
                this.dts_certificate_empresa.certificate='';
                this.dts_certificate_empresa.date_init='';
                this.dts_certificate_empresa.date_end='';
            },
            mShowModalUP(idM){
                $('#'+idM).modal('show');
            },
            mCloseModalUP(idM){
                $('#'+idM).modal('hide');
            },
            mValidateDescriptionChange(){
                try {
                    let auxDescription=this.description_transfer.trim();
                    if(this.description_transfer===null || auxDescription.length===0){
                        toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01');
                        return false;
                    }
                    return true;    
                } catch (error) {
                    console.log('error ')
                }
                
            },
            mViewSearchShip(event){
                // console.log(event);
                let radios=$("input[type=radio]").parent('label');
                console.log(radios);
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                // console.log(radioV);
                this.optionSearchShip=radioV;
            },
            mViewSearchPerson(event){
                console.log(event);
                let radios=$("input[type=radio]").parents('label');
                console.log(radios);
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                console.log(radioV);
                this.optionSearchPerson=radioV;
            },
            mCloseSelectPerson(){
                this.empresa_persona_select.id=0;
                this.empresa_persona_select.type_identification=0;
                this.empresa_persona_select.number_identification=0;
                this.empresa_persona_select.site_expedition=0;
                this.empresa_persona_select.name=null;
                this.empresa_persona_select.direction=null;
                this.empresa_persona_select.mobile=null;
                this.empresa_persona_select.phone=null;
                this.empresa_persona_select.partner=null;
                this.empresa_persona_select.nationality=0;
                this.certificatesEmpresa=[];
            },
            async mChargeCertificatesEmpresa(id_owner, quantity=5){
                this.certificatesEmpresa=[];
                quantity=quantity>0?quantity:5;
                let registrosOld=await axios.get(`getListAutorizacionEmpresa/${id_owner}/${quantity}?api_token=${Vue.auth.getToken()}`);
                registrosOld.data.forEach((dte)=>{
                    let aux_state,estilo;
                    switch(dte.estado_certificado){
                        case 'A':
                            aux_state='ACTIVO';
                            estilo='success'
                            break;
                        case 'I':
                            aux_state='INACTIVO';
                            estilo='danger'
                            break;
                        case 'V':
                            aux_state='VENCIDO';
                            estilo='warning'
                            break;
                    }
                    let aux_cert={
                        cuenca:dte.cuenca,
                        dato_identificacion:dte.dato_identificacion,
                        detalle_puerto:dte.detalle_puerto,
                        estado_certificado:aux_state,
                        fecha_inicio:dte.fecha_inicio,
                        fecha_vencimiento:dte.fecha_vencimiento,
                        id:dte.id,
                        nombre_muelle:dte.nombre_muelle,
                        nombre_propietario:dte.nombre_propietario,
                        numero_certificado:dte.numero_certificado,
                        servicio_presta:dte.servicio_presta,
                        estilo:estilo
                    }
                    this.certificatesEmpresa.push(aux_cert);
                })
                // this.certificatesEmpresa=registrosOld.data;
            },
            mSelectPersonOwner(sp){
                this.empresa_persona_select.id=sp.id_propietario;
                this.empresa_persona_select.type_identification=sp.tipo_identificacion;
                this.empresa_persona_select.number_identification=sp.dato_identificacion;
                this.empresa_persona_select.site_expedition=sp.id_expedido;
                this.empresa_persona_select.name=sp.nombre_propietario;
                this.empresa_persona_select.direction=sp.domicilio;
                this.empresa_persona_select.mobile=sp.celular;
                this.empresa_persona_select.phone=sp.telefono_fijo;
                this.empresa_persona_select.partner=sp.representante_legal;
                this.empresa_persona_select.nationality=sp.id_nacionalidad;
                // this.mChangeOwnerIdentificationEdit();
                this.mChargeCertificatesEmpresa(sp.id_propietario);
            },
            buscaDataPerson(){
                // console.log(`${this.optionSearch} tipo`);
                // console.log(`${this.data_person}`);
                if(this.data_person !== null || this.data_person.trim().length > 0 ){
                    console.log('enviando al servidor');
                    axios.get(`searchOwnerType/${this.data_person}/${this.optionSearchPerson}?api_token=${Vue.auth.getToken()}`)
                        .then((res) => {                    
                            this.list_empresa_persona_select = res.data
                            // this.users = res.data.items
                        }).catch(error => {
                            console.log(error);
                        })
                }else{
                    toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
                }
            },
            mSelectShipOwner(sbp){
                this.ship_select.id=sbp.id_boat;
                this.ship_select.name_boat=sbp.name_boat;
                this.ship_select.enrollment=sbp.enrollment;
                this.ship_select.enrollment_old=sbp.enrollment_old;
                this.ship_select.trb=sbp.trb;
                this.ship_select.trn=sbp.trn;
                this.old_owner.id=sbp.id_propietario;
                this.old_owner.name=sbp.nombre_propietario;
                this.old_owner.documento=sbp.dato_identificacion;
                // this.mChangeOwnerIdentificationEdit();
            },
            mReportCertificates(certificado, id){
                // console.log(`el certificado es ${certificado}, el id es ${id}`);
                // this.modal_report_url=`pdfUUMM/${certificado}`;
                this.id_report=id;
                this.mShowModalUP(this.id_modal_r);
                this.mCloseModalUP(this.idModalL);            
            },
            mCallPrint(idb){
                // this.modalLoadTitle='Solicitando';
                // this.mShowModalRec(this.modalPro);
                this.id_report=idb;
                this.modal_report_url=`pdfReportBoat`;
                this.mShowModalUP(this.id_modal_r);
                this.mCloseModalUP(this.idModalL);
                            
            }
        },
        components:{
            'modal-loading':modalLoading,
            'modal-report':modalReport
        },
        computed:{
            searchTypeShip(){
                switch(this.optionSearchShip){
                    case 'name':
                        return 'Nombre de la Nave';
                    break;
    
                    case 'enrollment':
                        return 'Matricula de la Nave';
                    break;
                }
            },
            searchTypePerson(){
                switch(this.optionSearchPerson){
                    case 'name':
                        return 'Nombre de la Persona';
                    break;
    
                    case 'document':
                        return 'Cedula de la Persona';
                    break;
                }
            }
        },
        filters:{
            upperCase(value){
                return value.toUpperCase();
            }
        }
    }
    </script>
    
    <style>
        .required-text{
            color:red; 
            font-weight:bold;
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/uumm/RegisterEmpresaPuerto.vue